import Filter from '@/components/trials/filter/filter';
import styles from './filter-modal.module.css';
import Modal from '@/components/modal/modal';

type FilterModalProps = {
	isOpen: boolean;
	onClose: () => void;
};
export default function FilterModal({ isOpen, onClose }: FilterModalProps) {
	return (
		<Modal isOpen={isOpen} onClose={onClose} auto>
			{/* <Modal.Title>
				<div className={styles['dialog-title']}>Trials Filters</div>
			</Modal.Title> */}
			<Modal.Body>
				<div className={styles.body}>
					<Filter />
				</div>
			</Modal.Body>
			<Modal.Footer>
				<div className={styles.footer}>
					<button type='button' className={styles.cancel} onClick={onClose}>
						Cancel
					</button>
				</div>
			</Modal.Footer>
		</Modal>
	);
}
